declare global {
  interface Window {
    datadogRum: {
      addRumGlobalContext: (name: string, config: { [key: string]: unknown }) => void;
      addAction: (action: string, details: { [key: string]: unknown }) => void;
    };
  }
}

const metricsLoggingEnabled = localStorage.getItem('perf-metrics') === '1';

/**
 * Logs a given measurement to DD.
 * This function also logs the measurement to console if `perf-metrics` is set to 1 on local storage.
 */
export default (
  measurement: PerformanceMeasure,
  extra: { [key: string]: unknown; routeChange: boolean } = { routeChange: false },
): void => {
  if (metricsLoggingEnabled) {
    // eslint-disable-next-line no-console
    console.info(
      '%c[HJ-PERFORMANCE]',
      'color: orange; font-weight: bold;',
      measurement.name,
      `| Time: ${Math.round(measurement.duration)}ms (${Math.round(
        measurement.startTime,
      )}ms to ${Math.round(measurement.startTime + measurement.duration)}ms)`,
      extra.routeChange ? '(route change)' : '',
    );
  }

  // RUM is disabled in development environments
  if (!Object.prototype.hasOwnProperty.call(window, 'datadogRum')) return;

  window.datadogRum.addAction(measurement.name, {
    time: measurement.duration,
    startTime: measurement.startTime,
    endTime: measurement.duration + measurement.startTime,
    ...extra,
  });
};
